// 576054706193-7bf4rr04ci9ppofk5okmv6cgujcd4ima.apps.googleusercontent.com
//Client Secret
// mehZdDqigjLLUghY8GRD8yg9

// 576054706193-3d9vvt567sq6npl6u1h7vk1697tbjmag.apps.googleusercontent.com
// lc4ECqtRFPg3PvKhV4MGDcxD

/* <SocialButton
            provider="google"
            appId="576054706193-3d9vvt567sq6npl6u1h7vk1697tbjmag.apps.googleusercontent.com"
            onLoginSuccess={handleSocialLogin}
            onLoginFailure={handleSocialLoginFailure}
        >
            Login with Google
        </SocialButton> */

import React, { Fragment } from "react"
// import SocialLogin from "react-social-login"
import styled from "react-emotion"

import Input from "ui/components/Input"
import { Section, Container, Heading, Text, Card, Button } from "ui"

import { ContentWrapper, Content } from "../studio/ui/Layout"
import { SignupApi } from "./utils"
import { withRouter } from "react-router"
import { Helmet } from "react-helmet"
const queryString = require("qs")


class SignupPage extends React.Component {
    state = {}

    render() {
        window.Intercom("boot", {
            app_id: (window.location.hostname === "studio.stacker.app" ? "txwvzciy" : "bu5482h5"),
            //Logged out user so may not have any user related info
        })
        const query = queryString.parse(this.props.location.search.slice(1)) // Slice to remove the "?"
        return (
            <React.Fragment>
                <Helmet>
                    <link rel="shortcut icon" href="/favicon.clear.png" type="image/png" />
                    <meta charSet="utf-8" />
                    <title>Stacker Studio</title>
                </Helmet>
                <ContentWrapper>
                    <Content>
                        <LoginFrame>
                            <Logo
                                src="/static/media/stacker-logo.32813f5d.png"
                                alt="Stacker Logo"
                                style={{ marginBottom: 32, marginTop: 18 }}
                            />
                            <LoginPanel>
                                <Heading size="medium">Start your 14-day free trial</Heading>
                                <Section margin="medium" padding="none">
                                    <LoginInput
                                        onChange={e => this.setState({ name: e.target.value })}
                                        padding="medium"
                                        placeholder="Full Name"
                                        defaultValue={query.name}
                                    />
                                </Section>
                                <Section margin="medium" padding="none">
                                    <LoginInput
                                        onChange={e => this.setState({ email: e.target.value })}
                                        padding="medium"
                                        placeholder="Email"
                                        defaultValue={query.email}
                                    />
                                </Section>
                                <Section margin="medium" padding="none">
                                    <LoginInput
                                        type="password"
                                        onChange={e => this.setState({ password: e.target.value })}
                                        padding="medium"
                                        placeholder="Password"
                                    />
                                </Section>
                                <Container margin="medim">
                                    <Button
                                        onClick={this.login}
                                        width="300px"
                                        margin="large"
                                        color="success"
                                    >
                                        Register
                                </Button>
                                </Container>
                            </LoginPanel>
                            {this.state.passwordTooShort && (
                                <Text style={{ color: "red" }}>
                                    Please enter at least 8 characters for your password
                            </Text>
                            )}
                            {this.state.error && (
                                <Text style={{ color: "red" }}>
                                    Unable to complete registration. Make sure you've filled in all the
                                    fields, and that your email is not already registered
                            </Text>
                            )}
                            <Text style={{ color: "grey" }}>
                                Already have an account? <a href="/login">Sign in</a>
                            </Text>
                        </LoginFrame>
                    </Content>
                </ContentWrapper>
            </React.Fragment>
        )
    }

    login = () => {
        const { name, email, password } = this.state
        if (password && password.length < 8) {
            this.setState({ passwordTooShort: true })
            return
        } else if (password && password.length >= 8) {
            this.setState({ passwordTooShort: false })
        }
        SignupApi.signup({ name, email, password }).then(response => {
            let token = response.api_token
            if (!token) {
                this.setState({ error: true })
                return
            }

            window.intercomSettings = {
                app_id: "txwvzciy",
                name: name, // Full name
                email: email, // Email address
                created_at: new Date(), // Signup Date
            }

            window.Intercom("boot", window.intercomSettings)

            localStorage.setItem("studio_token", token)
            localStorage.setItem("user", response)
            this.props.router.push("/")
        })
    }
}

export default withRouter(SignupPage)

const LoginInput = styled(Input)`
    width: 300px;
`

const LoginPanel = styled(Card)`
    width: 100%;
    height: 100%;
    align-items: center;
    padding: 2%;
`

const LoginFrame = styled("div")`
    width: 100%;
    max-width: 400px;
    height: 430px;
    margin: 10% auto;
    text-align: center;
`

const Logo = styled("img")`
    width: 100%;
    max-width: 300px;
    display: block;
    margin: 0px auto ${props => props.theme.medium};
`

// const SocialButton = SocialLogin(({ children, triggerLogin, ...props }) => (
//     <button onClick={triggerLogin} {...props}>
//         {children}
//     </button>
// ))

// const handleSocialLogin = user => {
//     console.log(user)
// }

// const handleSocialLoginFailure = err => {
//     console.error(err)
// }



// WEBPACK FOOTER //
// ./src/features/auth/SignupPage.js